import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from "react";
import { Box, Pressable, Text } from "native-base";
import { PregnancyWellBeingStatus } from "@madmedical/medical";
import PregnantMoodPics from "../molecules/Pregnancy/PregnantMoodPics";
import { commentDropSlot } from "./useStyles";
export default function MoodDrop({ graphData = {}, timeData, moodGroup, setMoodGroup, setTooltip, setCommentState, }) {
    const { limits, moods = [], randomIdFragment = "" } = graphData;
    const { timeStamps = [], timeCoords } = timeData;
    const memoMoods = useMemo(() => {
        const groupedMoods = Array.from({ length: timeStamps.length }, () => []);
        moods.forEach((mood) => {
            var _a;
            if (mood.msec) {
                const getMsec = mood.msec;
                const intervalIndex = timeCoords.findIndex(({ msec }) => getMsec <= msec) - 1;
                (_a = groupedMoods[intervalIndex]) === null || _a === void 0 ? void 0 : _a.push(mood);
            }
        });
        const mergedMoods = groupedMoods.map((group, groupIndex) => {
            if (group.length === 0)
                return null;
            const avatar = group.length === 1 ? group[0].status : "";
            return {
                status: groupedMoods[groupIndex],
                avatar,
                x: timeCoords[groupIndex].x,
            };
        });
        return {
            groupedMoods,
            mergedMoods,
        };
    }, [moods, timeCoords, timeStamps]);
    return (_jsx(_Fragment, { children: !!memoMoods.mergedMoods.length &&
            memoMoods.mergedMoods.map((group, i) => {
                var _a;
                const id = `${randomIdFragment}-mood-group-pos-${i}`;
                const avatar = group === null || group === void 0 ? void 0 : group.avatar;
                const firstAvatar = (_a = group === null || group === void 0 ? void 0 : group.status[0]) === null || _a === void 0 ? void 0 : _a.status;
                const colors = {
                    [PregnancyWellBeingStatus.BadTemper]: "#A786A9",
                    [PregnancyWellBeingStatus.Moody]: "#6793AC",
                    [PregnancyWellBeingStatus.Fluctuating]: "#7B9791",
                    [PregnancyWellBeingStatus.Calm]: "#EBA46A",
                    [PregnancyWellBeingStatus.Cheerful]: "#EBA388",
                };
                const dropBgColor = avatar ? colors[avatar] : "gray.800";
                const activeColor = colors[firstAvatar];
                return group ? (_jsx(Box, Object.assign({ position: "absolute", zIndex: 2, style: {
                        left: group.x,
                        bottom: limits === null || limits === void 0 ? void 0 : limits.yMax,
                        transform: [
                            { translateY: 20 },
                            {
                                scale: moodGroup.onShow &&
                                    moodGroup.id === id
                                    ? 1.1
                                    : 1,
                            },
                        ],
                    } }, { children: _jsx(Pressable, Object.assign({ onPress: () => {
                            setMoodGroup((state) => (Object.assign(Object.assign({}, group), { id, onShow: state.id === id
                                    ? !state.onShow
                                    : true })));
                            setTooltip((state) => (Object.assign(Object.assign({}, state), { onShow: false })));
                            setCommentState((state) => (Object.assign(Object.assign({}, state), { onShow: false })));
                        } }, { children: _jsx(Box, Object.assign({ nativeID: id, style: commentDropSlot, backgroundColor: moodGroup.onShow && moodGroup.id === id
                                ? activeColor
                                : dropBgColor }, { children: avatar ? (_jsx(Box, Object.assign({ w: "16px", h: "16px", alignItems: "center", rounded: "full", overflow: "hidden" }, { children: _jsx(PregnantMoodPics, { status: avatar }) }))) : (_jsx(Box, Object.assign({ borderRadius: "full", alignItems: "center", justifyContent: "center", w: "16px", h: "16px", rounded: "full", bg: "white" }, { children: _jsx(Text, Object.assign({ fontSize: "10px", fontWeight: "medium", color: moodGroup.onShow &&
                                        moodGroup.id === id
                                        ? activeColor
                                        : dropBgColor }, { children: group.status.length })) }))) }), id) })) }), id)) : (_jsx(Fragment, {}, id));
            }) }));
}
